import { render, staticRenderFns } from "./tagsView.vue?vue&type=template&id=d1018d96&scoped=true&"
import script from "./tagsView.vue?vue&type=script&lang=js&"
export * from "./tagsView.vue?vue&type=script&lang=js&"
import style0 from "./tagsView.vue?vue&type=style&index=0&id=d1018d96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1018d96",
  null
  
)

export default component.exports